// src/features/planning/routes.tsx
// ADR-092 Rule PLN-FE-07 + ADR-094 Rule MRP-FE-02. Consumed by
// src/routes/router.tsx (Aggregator, ADR-072 Rule FMS-03) — add the
// import + spread there manually, do not rewrite router.tsx wholesale.

import type { RouteObject } from "react-router-dom";

import { PlanningHomePage } from "./pages/PlanningHomePage";
import { MasterScheduleListPage } from "./pages/MasterScheduleListPage";
import { MasterScheduleCreatePage } from "./pages/MasterScheduleCreatePage";
import { MasterScheduleDetailPage } from "./pages/MasterScheduleDetailPage";
import { MasterScheduleRevisionEditorPage } from "./pages/MasterScheduleRevisionEditorPage";
import { MrpRunListPage } from "./pages/MrpRunListPage";
import { MrpRunDetailPage } from "./pages/MrpRunDetailPage";
import { WorkCenterCapacityProfileListPage } from "./pages/WorkCenterCapacityProfileListPage";
import { CapacityCheckPage } from "./pages/CapacityCheckPage";

import { PlanningHomeHelpPage } from "@/features/planning/pages/help/PlanningHomeHelpPage";
import { MasterSchedulesHelpPage } from "@/features/planning/pages/help/MasterSchedulesHelpPage";
import { MrpRunsHelpPage } from "@/features/planning/pages/help/MrpRunsHelpPage";
import { CapacityCheckHelpPage } from "@/features/planning/pages/help/CapacityCheckHelpPage";
import MasterScheduleCreateHelp from "./help/master-schedule-create.mdx";
import MasterScheduleDetailHelp from "./help/master-schedule-detail.mdx";
import MasterScheduleRevisionEditorHelp from "./help/master-schedule-revision-editor.mdx";
import MrpRunDetailHelp from "./help/mrp-run-detail.mdx";
import WorkCenterCapacityProfileListHelp from "./help/work-center-capacity-profile-list.mdx";

export const planningRoutes: RouteObject[] = [
  { path: "help/planning/planning-home", element: <PlanningHomeHelpPage /> },
  { path: "help/planning/master-schedules", element: <MasterSchedulesHelpPage /> },
  { path: "help/planning/mrp-runs", element: <MrpRunsHelpPage /> },
  { path: "help/planning/capacity-check", element: <CapacityCheckHelpPage /> },
  { path: "help/planning/master-schedule-create", element: <MasterScheduleCreateHelp /> },
  { path: "help/planning/master-schedule-detail", element: <MasterScheduleDetailHelp /> },
  { path: "help/planning/master-schedule-revision-editor", element: <MasterScheduleRevisionEditorHelp /> },
  { path: "help/planning/mrp-run-detail", element: <MrpRunDetailHelp /> },
  { path: "help/planning/work-center-capacity-profiles", element: <WorkCenterCapacityProfileListHelp /> },
  { path: "planning", element: <PlanningHomePage /> },
  { path: "planning/master-schedules", element: <MasterScheduleListPage /> },
  {
    path: "planning/master-schedules/new",
    element: <MasterScheduleCreatePage />,
  },
  {
    path: "planning/master-schedules/:familyId",
    element: <MasterScheduleDetailPage />,
  },
  {
    path: "planning/revisions/:revisionId",
    element: <MasterScheduleRevisionEditorPage />,
  },
  // ADR-094 (Phase P2)
  { path: "planning/mrp-runs", element: <MrpRunListPage /> },
  { path: "planning/mrp-runs/:runId", element: <MrpRunDetailPage /> },
  // ADR-098 (Phase P3)
  { path: "planning/capacity-profiles", element: <WorkCenterCapacityProfileListPage /> },
  { path: "planning/capacity-check", element: <CapacityCheckPage /> },
];
